import {showErrorMessage} from "@/helper";

export default {
    fetchRecords(body) {
        return new Promise((resolve, reject) => {
            http.post('api/intermediaries/list', {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getAll(style = 'default') {
        return new Promise((resolve, reject) => {
            http.get('api/intermediaries' + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getIntermediary(id, style = null) {
        return new Promise((resolve, reject) => {
            http.get('api/intermediaries/' + id + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error.response?.data?.message) {
                    showErrorMessage(error.response.data.message);
                }
                reject(error);
            });
        });
    },

    saveIntermediary(data, intermediaryId = null) {
        return new Promise((resolve, reject) => {
            http.post('api/intermediaries' + (intermediaryId ? '/' + intermediaryId : ''), data, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    deleteIntermediary(intermediaryId) {
        return new Promise((resolve, reject) => {
            http.delete('api/intermediaries/' + intermediaryId).then(response => {
                resolve(response.data);
            }).catch(error => {
                showErrorMessage(error.response.data.message);
                //reject([]);
            });
        });
    },

    deleteIntermediaryLogo(intermediaryId) {
        return new Promise((resolve, reject) => {
            http.delete('api/intermediaries/' + intermediaryId + '/logo').then(response => {
                resolve(response.data);
            }).catch(error => {
                showErrorMessage(error.response.data.message);
                //reject([]);
            });
        });
    }
}
